import moment from 'moment';
import { BaseColumn } from '../../../../models/dsy-table.model';
import { PastDispatchTableRow } from '../../../../models/performance-view.model';
import { LocaleTimeUtils } from '../../../shared/utils/locale-time.utils';
import { sortByDate, sortByNumber, sortByString } from '../../../shared/utils/columns-sorter.util';

export type PastDispatchColumnKey =
  | 'portfolio'
  | 'product'
  | 'program'
  | 'organization'
  | 'site'
  | 'eventDateUtc'
  | 'enrolled'
  | 'delivered'
  | 'performance'
  | 'dataQuality'
  | 'action';

// Program view
export const PROGRAM_PRODUCT_COLUMNS: readonly BaseColumn<PastDispatchTableRow, PastDispatchColumnKey>[] = [
  { key: 'product', header: 'PD.TABLE.PRODUCT', accessor: r => r.product, sortFunction: (a, b, o) => sortByString(a, b, o, 'product') },
  { key: 'eventDateUtc', header: 'PD.TABLE.EVENT_DATE', accessor: r => r.eventStartDateUtc, exportAccessor: formatEventRangeForExport, sortFunction: (a, b, o) => sortByDate(a, b, o, 'eventStartDateUtc') },
  { key: 'enrolled', header: 'PD.TABLE.ENROLLED_KW', accessor: r => r.enrolled, sortFunction: (a, b, o) => sortByNumber(a, b, o, 'enrolled') },
  { key: 'delivered', header: 'PD.TABLE.DELIVERED_KW', accessor: r => r.delivered, sortFunction: (a, b, o) => sortByNumber(a, b, o, 'delivered') },
  { key: 'performance', header: 'PD.TABLE.PERFORMANCE_PERCENT', accessor: r => r.performance, sortFunction: (a, b, o) => sortByNumber(a, b, o, 'performance') },
  { key: 'dataQuality', header: 'PD.TABLE.DATA_QUALITY', accessor: r => r.dataQuality, sortFunction: (a, b, o) => sortByString(a, b, o, 'dataQuality') },
  { key: 'action', header: '', accessor: () => '' },
] as const;

// Organization view
export const ORGANIZATION_COLUMNS: readonly BaseColumn<PastDispatchTableRow, PastDispatchColumnKey>[] = [
  { key: 'site', header: 'PD.TABLE.SITE', accessor: r => r.site, sortFunction: (a, b, o) => sortByString(a, b, o, 'site') },
  { key: 'program', header: 'PD.TABLE.PROGRAM', accessor: r => r.program, sortFunction: (a, b, o) => sortByString(a, b, o, 'program') },
  { key: 'organization', header: 'PD.TABLE.ORGANIZATION', accessor: r => r.organization, sortFunction: (a, b, o) => sortByString(a, b, o, 'organization') },
  { key: 'eventDateUtc', header: 'PD.TABLE.EVENT_DATE', accessor: r => r.eventStartDateUtc, exportAccessor: formatEventRangeForExport , sortFunction: (a, b, o) => sortByDate(a, b, o, 'eventStartDateUtc')},
  { key: 'enrolled', header: 'PD.TABLE.ENROLLED_KW', accessor: r => r.enrolled, sortFunction: (a, b, o) => sortByNumber(a, b, o, 'enrolled')},
  { key: 'delivered', header: 'PD.TABLE.DELIVERED_KW', accessor: r => r.delivered, sortFunction: (a, b, o) => sortByNumber(a, b, o, 'delivered')},
  { key: 'performance', header: 'PD.TABLE.PERFORMANCE_PERCENT', accessor: r => r.performance, sortFunction: (a, b, o) => sortByNumber(a, b, o, 'performance')},
  { key: 'dataQuality', header: 'PD.TABLE.DATA_QUALITY', accessor: r => r.dataQuality, sortFunction: (a, b, o) => sortByString(a, b, o, 'dataQuality')},
  { key: 'action', header: '', accessor: () => '' },
] as const;

function formatEventRangeForExport(row: PastDispatchTableRow, locale?: string): string {
  const start = moment.utc(row.eventStartDateUtc);
  const end = moment.utc(row.eventEndDateUtc);
  const startDate = LocaleTimeUtils.formatShortDate(start.toDate(), locale, { timeZone: 'UTC' });
  const endDate = LocaleTimeUtils.formatShortDate(end.toDate(), locale, { timeZone: 'UTC' });
  const timeFormat = LocaleTimeUtils.is24HourLocale(locale) ? 'HH:mm' : 'h:mma';
  return `${startDate} ${start.format(timeFormat)} - ${endDate} ${end.format(timeFormat)} GMT`;
}
